export class NeedForEducationalSP{
    id : number;
    code : string;
    name : string;
    /*Chon phuong thuc giao duc*/
    isEarlyIntervention: boolean;
    /*Phuong tien, thiet bi giao duc*/
    isEducationFacilitiesEquipment: boolean;
    /*Phuong tien ho tro ca nhan*/
    isApprentice : boolean;
    /*Ho tro khac*/
    isRequiredNote : boolean;
    displayOrder : number;
  } 